import { chopinEnvironment } from "../utils/chopinEnvironment";

// IDM Airbrake Values
export const AIRBRAKE_PROJECT_ID: number = 596261;
export const AIRBRAKE_PROJECT_KEY = "087fa89dae55f9f3c3454d6eb13bd6e3";

export const IDM_POST_OPTIONS = {
  method: "POST",
  headers: {
    Accept: "application/json; charset=utf-8",
    "Content-Type": "application/json; charset=utf-8",
  },
};

export const IPS_POST_OPTIONS = {
  method: "POST",
  headers: {
    Accept: "application/json; charset=utf-8",
    "Content-Type": "application/json; charset=utf-8",
  },
};

export const DEFAULT_POLLING_INTERVAL = 5000;

export const MAX_IDLE_TIME = 5000;

export const IDM_API_URLS = (ENV_OVERRIDE: string | undefined = undefined) => {
  const environment = ENV_OVERRIDE || chopinEnvironment();

  if (environment === "production") {
    return "https://intervention-decision-mechanism.api.simplybusiness.com/v1";
  }
  if (["test", "staging"].includes(environment)) {
    return "https://intervention-decision-mechanism-staging.api.simplybusiness.com/v1";
  }

  return "http://localhost:1415/v1";
};

export const IPS_API_URLS = (ENV_OVERRIDE: string | undefined = undefined) => {
  const environment = ENV_OVERRIDE || chopinEnvironment();

  if (environment === "production") {
    return "https://indicative-pricing.api.simplybusiness.com";
  }
  if (["test", "staging"].includes(environment)) {
    return "https://indicative-pricing-staging.api.simplybusiness.com";
  }

  //NB: same as staging for now. Note that CORS will likely fail here if this is used locally.
  return "https://indicative-pricing-staging.api.simplybusiness.com";
};

export const IP_WIDGET_SCRIPT_URLS = (
  ENV_OVERRIDE: string | undefined = undefined,
) => {
  const environment = ENV_OVERRIDE || chopinEnvironment();

  if (environment === "production") {
    return "https://embed.simplybusiness.com/ip/loader.js";
  }

  return "https://embed-dev.simplybusiness.com/ip/loader.js";
};

export const IP_WIDGET_ORIGIN_SITE = (
  site?: string,
  envOverride: string | undefined = undefined,
) => {
  //Site falls back to SB (uk) if not specified
  const ipSite = site || "simplybusiness";

  //Environment is staging if not production (no suffix = production)
  const environment =
    (envOverride || chopinEnvironment()) === "production" ? "" : "_staging";

  return ipSite + environment;
};

export const DEFAULT_UK_TRADES_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "https://quote.simplybusiness.co.uk/trade_search"
    : "https://quote-staging.simplybusiness.co.uk/trade_search";
